import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var LightbulbOffIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M11.5 4C8.442 4 6 6.421 6 9.364c0 2.06 1.228 3.007 2.218 3.77.272.21.526.405.732.606.479.47.782.946.929 1.55.055.227.085.465.101.71h3.055c.025-.268.065-.525.13-.77a3.157 3.157 0 01.885-1.49c.206-.201.46-.397.732-.607.99-.762 2.218-1.71 2.218-3.77C17 6.422 14.558 4 11.5 4zM7.935 15.762c.06.243.065.558.065 1.238a1 1 0 001 1h5a1 1 0 001-1c0-.633.028-.994.097-1.253.057-.213.147-.376.353-.578.046-.046.144-.116.279-.213.87-.627 3.271-2.357 3.271-5.592C19 5.277 15.622 2 11.5 2S4 5.277 4 9.364c0 3.235 2.401 4.965 3.271 5.592.135.097.233.168.28.213.272.266.344.426.384.593zM10 22a2 2 0 01-2-2 1 1 0 011-1h5a1 1 0 011 1 2 2 0 01-2 2 1 1 0 01-1 1h-1a1 1 0 01-1-1z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
LightbulbOffIcon.isCarinaIcon = true;
export default LightbulbOffIcon;
